
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class QuestionnaireSidebarStep extends Vue {
  @Prop({ type: Number, required: true }) readonly number!: number;
  @Prop({ type: String, required: true }) readonly label!: string;
  @Prop({ type: Boolean, default: false }) readonly checked!: boolean;
  @Prop({ type: Boolean, default: false }) readonly active!: boolean;

  namespace = "questionnaire-sidebar";

  get stepClass() {
    const { namespace, active } = this;

    return {
      [`${namespace}__step_active`]: active,
    };
  }
}
